export default __webpack_public_path__ + "static/media/close.680ef137.svg";